import React from "react";
import { Navigate } from "react-router-dom";
import useAuthStore from "../../hooks/useAuthStore";

export default function GuestRoute({ children }) {
  const { user, loading } = useAuthStore();

  if (loading) {
    return <div className="p-4 text-center">Loading...</div>;
  }

  if (user) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}